import {Component} from '@angular/core';

@Component({
  selector: 'ax-subscribe-theme',
  template: '<ng-content></ng-content>',
  styleUrls: ['subscribe-theme.component.scss'],
})
export class SubscribeThemeComponent {}
